import React from "react";
import processBoxStyle from "./processBoxStyle";
import { Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import _map from "lodash/map";
import { getProcessConfig } from "@/src/services/serviceWorldService";
import IconCheckCircleBig from "@/src/assets/icons/serviceOverview/IconCheckCircleBig";
import IconProgress from "@/src/assets/icons/serviceOverview/IconProgress";
import { ProcessBoxLoader } from "@/src/components/ContentLoader/ProcessBoxLoader";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import IconWrapper from "@/src/components/IconWrapper/IconWrapper";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type ProcessBoxProp = {
  product: AbstractCase;
};

const ProcessBox = ({ product }: ProcessBoxProp) => {
  if (!product) {
    return (
      <ContentBox headline={"Prozessablauf"} icon={IconProgress} loading={!product}>
        <ProcessBoxLoader />
      </ContentBox>
    );
  }

  if (product.isCustomerDataCompleted) {
    return null;
  }

  const processConfig = getProcessConfig(product);

  if (!processConfig) {
    return null;
  }

  return (
    <ContentBox headline={processConfig.headline}>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {_map(processConfig.steps, (step, index: number) => (
          <Grid key={index} size={{ xs: 12, md: 4 }} sx={[processBoxStyle.textBlock, step.done ? processBoxStyle.done : null]}>
            <Typography sx={{ marginBottom: "1rem" }} component={"div"}>
              <Stack direction={"row"} sx={{ alignItems: "center" }} spacing={1}>
                {step.done ? (
                  <IconCheckCircleBig sx={processBoxStyle.progressIcons} />
                ) : (
                  <IconWrapper icon={step.icon} alt="Step Icon" sx={processBoxStyle.progressIcons} />
                )}
                <strong>{step.headline}</strong>
              </Stack>
            </Typography>
            <Typography sx={processBoxStyle.stepText}>{step.content}</Typography>
          </Grid>
        ))}
      </Grid>
    </ContentBox>
  );
};

export default ProcessBox;
